module.exports = __webpack_public_path__ + "img/tab-modal-move.d9cfeea4.svg";